import classnames from 'classnames'
import { observer } from 'mobx-react-lite'
import { useTheme, CacheProvider } from '@searchspring/snap-preact-components/dist/cjs/providers'
import { Fragment, h } from 'preact'
import { useState } from 'preact/hooks'
import { getContext } from "@searchspring/snap-toolbox";
import { useSearchResultTracking } from '../Tracking/useSearchResultTracking';


import './article.css';


export const Article = observer(properties => {
  const globalTheme = useTheme();

  const props = {
    layout: 'grid',
    ...globalTheme?.components?.result,
    ...properties,
    ...properties.theme?.components?.result,
}

const {
    result,
    hideTitle,
    hideBadge,
    hideContent,
    hideContentType,
    className,
    layout,
    isFirst,
    style,
    controller,
    index,
} = props

  const core = result?.mappings?.core
  const content = result?.attributes?.content;
  const type = result?.attributes?.type;
  const metafields = result?.attributes.metafields;
  let parsedMetafields;
  metafields ? parsedMetafields = JSON.parse(metafields) : null;
  let url;

  const context = getContext(['template']);

  context?.template === 'blog.magazine-issues' ? url  = `magazine#/afilter:mag_issue_number:${parsedMetafields?.mag_issue_number}/view:articles` : url = core.url

	const fallbackSrc =
    typeof window !== 'undefined' ? window?.resources?.blog_listing?.fallback_image_src : null
  const fallbackSrcset =
    typeof window !== 'undefined' ? window?.resources?.blog_listing?.fallback_image_srcset : null

  const [hasTriedFallback, setHasTriedFallback] = useState(false)
  const trackingRef = useSearchResultTracking(controller, result)

	const imgProps = {
    id: `ProductImage-${result.id}`,
    alt: core?.name,
    class: 'product__img product__img--main',
    'data-aspectratio': '1.4967637540453074',
    'data-sizes': 'auto',
    loading: index < 3 ? 'eager' : 'lazy',
    fetchpriority: index < 3 ? 'high' : 'auto',
    'data-image': true,
    src: `${core?.imageUrl}&width=200&quality=85`,
    srcSet: `${core?.imageUrl}&width=160&quality=85 160w, ${core?.imageUrl}&width=240&quality=85 240w, ${core?.imageUrl}&width=300&quality=85 300w, ${core?.imageUrl}&width=367&quality=85 367w`,
    sizes: '(max-width: 750px) 50vw, (max-width: 1422px) calc(33vw - 2rem), calc(25vw - 1rem)',
    onError: (e) => {
      if (fallbackSrc && !hasTriedFallback) {
        e.target.src = fallbackSrc
        if (fallbackSrcset) {
          e.target.srcset = fallbackSrcset
        } else {
          e.target.srcset = ''
        }
        setHasTriedFallback(true)
      }
    },
  }

  return (
    <CacheProvider>
     {!isFirst && (
        <article
            ref={trackingRef}
            className={classnames('ss__result ss__result-article', (typeof hoverImage != "undefined" && 'ss__result__hover'), `ss__result--${layout}`, className)}
        >
            <a
                href={url}
                onMouseDown={e => {
                    controller?.track?.product?.click(e, result)
                }}
                className="ss__result-link"
                aria-label={core.name}
            >
                <div className="product-card-top-wrapper">
                    <div className="ss__result__image-wrapper">
                        {!hideBadge && parsedMetafields?.premium && (
                                <div className={classnames('ss__badge ss__result__badge')}
                                  dangerouslySetInnerHTML={{
                                    __html: "Premium",
                                  }}
                                />
                            )}
                        <div className={classnames('ss__image', 'ss__result__image')}>
													<img {...imgProps} />
												</div>
                    </div>
                    <div className="ss__result__details">
                        {!hideContentType && (
                            <div
                                className="ss__result__details__type"
                                dangerouslySetInnerHTML={{
                                    __html: type,
                                }}
                            />
                        )}
                        {!hideTitle && (
                            <div
                                className="ss__result__details__content-title"
                                dangerouslySetInnerHTML={{
                                    __html: core.name,
                                }}
                            />
                        )}

                        {!hideContent && (
                            <div
                                className="ss__result__details__content"
                                dangerouslySetInnerHTML={{
                                    __html: content,
                                }}
                            />
                        )}
                    </div>
                </div>
                </a>
        </article>
     )}

     {isFirst && (
       <article ref={trackingRef} className={classnames('ss__result ss__result-article',  `ss__result--${layout}`, className)} style={{ backgroundImage: `url(${window.Resources.searchspring.issue.issueBackground})`  }}
        >
					<div className="ss__mag-first-issue-image">
						<img {...imgProps} />
          </div>
          <div className='ss__mag-first-issue-content'>
              {!hideTitle && (
              <div
                  className="ss__result__details__content-title"
                  dangerouslySetInnerHTML={{
                      __html: core.name,
                  }}
              />
            )}
             <div
                  className="ss__mag-issue-heading h2"
                  dangerouslySetInnerHTML={{
                      __html: `${window.Resources.searchspring.issue.issueHeading}`,
                  }}
              />

              <div
                  className="ss__mag-issue-content p"
                  dangerouslySetInnerHTML={{
                      __html: `${window.Resources.searchspring.issue.issueContent}`,
                  }}
              />

            <a
                href={url}
                onMouseDown={e => {
                    controller?.track?.product?.click(e, result)
                }}
                className="button button--custom-large button--primary"
            >
              {window.Resources.searchspring.issue.issueButton}
            </a>
          </div>
      </article>
     )}
    </CacheProvider>
    )
  }
)
